import { MouseEventHandler } from 'react'
import { Checkbox, Modal } from '../../../component'
import { State } from '../../../state'
import { useDispatch, useSelector } from 'react-redux'
import { CHANGE_PUSH_SETTINGS_ACTIONS } from '../../../action/push/push.constants'
import './push-message-settings-modal.scss'
import { PushSettingsEnum } from '../../../enum'
import { modifyPushSettings } from '../../../action/push'

interface PushMessageSettingsModalProps {
    onCloseClick?: MouseEventHandler
}

export const PushMessageSettingsModal = (props: PushMessageSettingsModalProps) => {
    const dispatch = useDispatch()

    const { questDailyClosing, questFridayBeforeLeagueClose, questWeeklyClosing, questMiddleOfTheWeek, eventsOneDayBeforeTheEvent, activityNotLogInForThreeDay, activityNotLogInForSixDay, activityDontBreakTheStreak, birthday, oneDayAfterRegistrationIfHaventCompletedAnyMission, markAsAFriend, friendConfirmed } = useSelector((state: State) => state.push.settings)

    const onPushSettingsChange = async (settingsId: number) => {
        dispatch({
            type: CHANGE_PUSH_SETTINGS_ACTIONS.CHANGE_PUSH_SETTINGS_CHANGE,
            settingsId: settingsId,
        })

        await modifyPushSettings()
    }

    return (
        <Modal>
            <div className="push-message-settings-modal">
                <div className="push-message-settings-modal__header">
                    <div className="push-message-settings-modal__title"> Általános értesítések kezelése </div>
                    <button className="close-button" onClick={props.onCloseClick}>
                        <img alt="bezárás gomb" src="/image/close.svg" />
                    </button>
                </div>

                <div className="">

                    <div className="divider-container">
                        <span className="divider-line" />
                        <span className="divider-text">Események</span>
                        <span className="divider-line" />
                    </div>

                    <div className="push-message-settings-modal__item">
                        <div className="push-message-settings-modal__item-checkbox-container">
                            <Checkbox checked={eventsOneDayBeforeTheEvent} id="keep-aspect-ratio" onChange={() => onPushSettingsChange(PushSettingsEnum.EventsOneDayBeforeTheEvent)} />
                        </div>
                        <div className="push-message-settings-modal__item-text-container">
                            <h3 className="push-message-settings-modal__item-title">Esemény előtt egy nappal értesítés</h3>
                            <h3 className="push-message-settings-modal__item-desc">A felhasználó értesítést kap az esemény kezdete előtt egy nappal, de csak akkor, ha jelentkezett rá.</h3>
                        </div>
                    </div>

                </div>

                <div className="push-message-settings-modal__footer">
                    <button className="button button-left-margin" type="button" onClick={props.onCloseClick}>
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    )
}
